<section #section id="franchise" class="franchise" aria-labelledby="franchise-title">
  <!-- the moving background: glows, rings, and the light under the pointer -->
  <div class="franchise__bg" aria-hidden="true">
    <span class="glow glow--warm"></span>
    <span class="glow glow--deep"></span>
    <span class="glow glow--pale"></span>
    <span class="rings"><i></i><i></i><i></i><i></i></span>
    <span class="franchise__light"></span>
  </div>

  <div class="container franchise__inner">
    <p class="eyebrow" appReveal>Franchise</p>
    <h2 id="franchise-title" class="franchise__title" appReveal="80">Join the Recliner <em>Revolution!</em></h2>
    <p class="franchise__lead" appReveal="160">
      Turn your entrepreneurial dreams into reality — own a Little Nap franchise today.
    </p>

    <div class="franchise__actions" appReveal="240">
      <a class="btn btn--light" [href]="franchise.apply" target="_blank" rel="noopener">
        Enquire about a franchise
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
      </a>
      <a class="btn btn--ghost" [href]="franchise.more" target="_blank" rel="noopener">Why partner with us</a>
    </div>

    <ul class="terms" appReveal="300">
      @for (term of franchise.terms; track term.label) {
        <li>
          {{ term.label }} <strong>{{ term.value }}</strong>
        </li>
      }
    </ul>
  </div>

  <!-- the cities, passing by (read out once, as a sentence, below) -->
  <div class="cities" aria-hidden="true">
    <p class="cities__caption">Franchises available nationwide</p>
    @for (row of rows; track $index; let back = $odd) {
      <div class="cities__row" [class.cities__row--back]="back">
        @for (lap of laps; track lap) {
          <div class="cities__lap">
            @for (city of row; track city) {
              <span class="city">{{ city }}</span>
            }
          </div>
        }
      </div>
    }
  </div>
  <p class="sr-only">Franchises available nationwide: {{ franchise.cities.join(', ') }}.</p>
</section>
